  import { createRouter, createWebHistory } from 'vue-router';
  import PublicLayout from '../layouts/PublicLayout.vue';
  import AdminLayout from '../layouts/AdminLayout.vue';
  import Home from '../views/public/Home.vue';
  import Dashboard from '../views/admin/Dashboard.vue';
  import Product from '../views/admin/Product.vue';
  import ProductDetail from '../views/public/ProductDetail.vue';
  import User from '../views/admin/User.vue';
  import About from '../views/public/About.vue';
  import Grosir from '../views/public/Grosir.vue';
  import HomeSetting from '../views/admin/HomeSetting.vue';
  import Eceran from '../views/public/Eceran.vue';
  import Contact from '../views/public/Contact.vue';
  import Banner from '../views/admin/Banner.vue';
  import AboutContact from '@/views/admin/AboutContact.vue';
  import SiteSetting from '@/views/admin/SiteSetting.vue';
  import Message from '@/views/admin/Message.vue';
  import Login from '@/views/admin/Login.vue';
  import Article from '@/views/admin/Article.vue';
import Category from '@/views/admin/Category.vue';

  function isAuthenticated() {
    return !!localStorage.getItem('token'); // Check the correct token key
  }

  const routes = [
    {
      path: '/',
      component: PublicLayout,
      children: [
        { path: '', component: Home, meta: { title: 'Home' } },
        { path: '/about', component: About, meta: { title: 'Tentang Kami' } },
        { path: '/grosir', component: Grosir, meta: { title: 'Grosir' } },
        { path: '/eceran', component: Eceran, meta: { title: 'Eceran' } },
        { path: '/contact-us', component: Contact, meta: { title: 'Kontak' } },
        { path: '/product/:id', component: ProductDetail, props: true, name: 'product-detail', meta: { title: 'Product Detail' } }
      ],
    },
    {
      path: '/login',
      component: Login,
      meta: { title: 'Admin Login', requiresGuest: true },
    },
    {
      path: '/admin',
      component: AdminLayout,
      children: [
        { path: '', component: Dashboard, meta: { title: 'Dashboard', requiresAuth: true } },
        { path: 'categories', component: Category, meta: { title: 'Manage Categories', requiresAuth: true } },
        { path: 'products', component: Product, meta: { title: 'Manage Products', requiresAuth: true } },
        { path: 'users', component: User, meta: { title: 'Manage Users', requiresAuth: true } },
        { path: 'home-section', component: HomeSetting, meta: { title: 'Home Settings', requiresAuth: true } },
        { path: 'banner-manager', component: Banner, meta: { title: 'Banner Manager', requiresAuth: true } },
        { path: 'about-contact-manager', component: AboutContact, meta: { title: 'About and Contact Manager', requiresAuth: true } },
        { path: 'site-setting', component: SiteSetting, meta: { title: 'Site Settings', requiresAuth: true } },
        { path: 'message', component: Message, meta: { title: 'Messages', requiresAuth: true } },
        { path: 'article', component: Article, meta: { title: 'Articles', requiresAuth: true } },
      ]
    }
  ];

  const router = createRouter({
    history: createWebHistory(),
    routes,
  });

  router.beforeEach((to, from, next) => {
    document.title = to.meta.title || 'Default Title'; // Set page title

    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (!isAuthenticated()) {
        next({ path: '/login' }); // Redirect to login if not authenticated
      } else {
        next();
      }
    } else if (to.matched.some(record => record.meta.requiresGuest)) {
      if (isAuthenticated()) {
        next({ path: '/admin' }); // Redirect to admin if already authenticated
      } else {
        next();
      }
    } else {
      next();
    }
  });

  export default router;
